import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import { Container, Grid, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ReactComponent as ArrowLeftSvg } from "../../../assets/svg/arrow-left.svg";
// import logo from "../../../assets/safe_truck_small_logo.png";
import logo from "../../../assets/safe_logo.png";
import { ReactComponent as CrossBtn } from "../../../assets/svg/CrossButton.svg";
import { ReactComponent as File } from "../../../assets/svg/File.svg";

import { useNavigate } from "react-router-dom";

import "./styles.css";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { operatorFileUploadRequest } from "../../../redux/operator/action";
import { useResponsive } from "../../../hooks/useResponsive";
import background_image from "../../../assets/png/background_image.png";
import storePersist, { localConstant } from "../../../services/localStorage";
import { useTranslation } from "react-i18next";

const OperatorUploadDocuments = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const lgUp = useResponsive("up", "lg");

  const { operatorSignUpData } = useSelector((state) => state.operatorReducer);
  const isLoggedIn = storePersist.get(localConstant.API_ACCESS_TOKEN);
  const [uploadedImage, setUploadedImage] = useState(null);

  const handleImageUploadChange = (e) => {
    const uploadedFile = e.target.files[0];
    setUploadedImage(uploadedFile);
  };

  const handleRemoveImage = () => {
    setUploadedImage(null);
  };

  const handleSubmitClick = () => {
    if (!uploadedImage) return;
    dispatch(
      operatorFileUploadRequest(
        uploadedImage,
        storePersist.get(localConstant.USER_ID)
          ? storePersist.get(localConstant.USER_ID)
          : operatorSignUpData?.user?.userId,
        isLoggedIn,
        (data) => {
          if (data?.userId || data?.data) {
            navigate(isLoggedIn ? "/operatorDashboard" : "/login");
          }
        },
      ),
    );
  };

  const renderDocumentsUploadView = (
    <>
      <Stack spacing={2}>
        <Grid container sx={{ mb: 3 }} direction={"row"}>
          <ArrowLeftSvg
            style={{ alignSelf: "center" }}
            onClick={() => {
              navigate(-1);
            }}
          />
          <Typography sx={{ ml: 1 }} variant="titleText" color="primary.main">
            {t("pages.operatorUploadDocuments.pageHeading")}
          </Typography>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="customLable"
            color="common.inputCustomLable"
            marginBottom={1}
          >
            {t("pages.operatorUploadDocuments.text01")} *
          </Typography>
          <Button
            variant="outlined"
            fullWidth
            startIcon={<CloudUploadIcon />}
            style={{
              backgroundColor: "#fff",
              color: "#1D5AB9",
              borderWidth: 2,
              borderColor: "#1D5AB9",
              marginBottom: 20,
            }}
            disabled={uploadedImage}
            component="label"
          >
            {t("pages.operatorUploadDocuments.text02")}
            <VisuallyHiddenInput
              type="file"
              onChange={handleImageUploadChange}
              accept="image/png, image/jpeg, application/pdf"
            />
          </Button>
          {uploadedImage && (
            <div className="uploaded_image uploaded_dl">
              <div className="left_section_uploaded_image">
                <span className="file_icon_wrapper">
                  <File className="file_icon" />
                </span>
                <Typography
                  variant="customLable"
                  color="common.inputCustomLable"
                >
                  {uploadedImage.name}
                </Typography>
              </div>
              <button className="cross_icon_btn" onClick={handleRemoveImage}>
                <CrossBtn className="cross_icon" />
              </button>
            </div>
          )}
        </Box>
      </Stack>
    </>
  );

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        paddingTop: 20,
        paddingBottom: 20,
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#80BCFF4F",
        backgroundImage: `url(${background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100vh",
      }}
    >
      <Box
        maxWidth="xs"
        sx={{
          flexGrow: 1,
          minHeight: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: ["column", "column", "row"],
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{ height: 1, padding: 0 }}
          >
            <img src={logo} alt="Your Alt Text" />
            <Card
              sx={{
                p: 3,
                width: 1,
                maxWidth: 430,
                marginBottom: lgUp ? "10px" : "0px",
              }}
              style={{
                position: "absolute",
                top: "29%",
                bottom: 0,
                overflow: "auto",
              }}
              className="form_container"
            >
              {renderDocumentsUploadView}
              <LoadingButton
                fullWidth
                sx={{ mt: 5, mb: 5 }}
                size="large"
                type="submit"
                variant="contained"
                color="inherit"
                className="submit_button"
                onClick={handleSubmitClick}
              >
                {t("commonLabels.text01")}
              </LoadingButton>
            </Card>
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

export default OperatorUploadDocuments;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
